// src/hooks/useSubscriptionTier.js
import { useState, useEffect } from 'react';

/**
 * Hook to fetch and manage user's subscription tier
 * Returns tier, loading state, and refresh function
 */
export default function useSubscriptionTier(userId) {
  const [tier, setTier] = useState('grandmaster');
  const [isFounder, setIsFounder] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTier = async () => {
    if (!userId) {
      setTier('grandmaster');
      setIsFounder(true);
      setSubscription(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      setIsFounder(true);
      setSubscription(null);
      setTier('grandmaster');
    } catch (err) {
      setError(err.message);
      setTier('grandmaster');
      setIsFounder(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTier();
  }, [userId]);

  return {
    tier,
    isFounder,
    subscription,
    loading,
    error,
    refresh: fetchTier,
  };
}
